/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_P1Inputs */

const tr_kullanim_s14_p1 = /** @type {(inputs: Kullanim_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket, aşağıdaki hallerde Kullanıcı hesabını askıya alabilir:`)
};

const en_kullanim_s14_p1 = /** @type {(inputs: Kullanim_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company may suspend the User account in the following cases:`)
};

const de_kullanim_s14_p1 = /** @type {(inputs: Kullanim_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen kann das Nutzerkonto in folgenden Fällen sperren:`)
};

const ru_kullanim_s14_p1 = /** @type {(inputs: Kullanim_S14_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания может приостановить учётную запись Пользователя в следующих случаях:`)
};

/**
* | output |
* | --- |
* | "The Company may suspend the User account in the following cases:" |
*
* @param {Kullanim_S14_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_p1 = /** @type {((inputs?: Kullanim_S14_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_p1(inputs)
	if (locale === "de") return de_kullanim_s14_p1(inputs)
	if (locale === "ru") return ru_kullanim_s14_p1(inputs)
	return tr_kullanim_s14_p1(inputs)
});